import { onLoad, onReady } from "../../exports/dom";
import { defineEvent } from "../../common/nexus";
import { events } from "../../exports/event-q-bus";
import { trackLegacySelectors } from "./async/tracking";
import { hardcoreLegacy, insertHtmlFragment } from "./async/fragment";
import { initializeMountingHooks, onMount, onUnmount } from "./async/hooks";
import type { EventLoaderEvents } from "../event-loader";
import { nexus } from "../../exports/nexus.js";

/*                                   */
nexus().dom.assignNamespace(
  {
    onLoad: defineEvent(),
    onReady: defineEvent(),
    onMount,
    onUnmount,
    insertHtmlFragment,
    activateInlineScripts: hardcoreLegacy.activateInlineScripts,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);

/*                                                 */
const legacy = events<EventLoaderEvents>();
legacy.once("assets.events.documentReady", (e) => onReady.set(e));
legacy.once("assets.events.windowLoad", (e) => onLoad.set(e));

/*                    */
initializeMountingHooks();
onLoad.sub(trackLegacySelectors);
